import { Component, Inject } from 'ng-metadata/core';
import * as angular from 'angular';
import './header.scss';

/**
 * @name mwMediaContactDocumentHeader
 * @module mw.components.contentDocuments
 *
 * @description
 * `<mw-media-contact-document-header>` is a component used to show the content of the header.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 */

const template = `
    <div class="mw-media-contact-document-header" layout="row">
        <ng-transclude class="mw-media-contact-document-header__source-avatar" ng-transclude-slot="mwContentDocumentSourceAvatar"></ng-transclude>
        <div class="mw-media-contact-document-header__detail" flex="100" layout="column" layout-align="space-between">
            <div class="mw-media-contact-document-header__detail-first-row">
                <ng-transclude ng-transclude-slot="mwContentDocumentAuthor"></ng-transclude>
            </div>
            <div flex="initial" layout="row">
              <ng-transclude md-truncate flex="initial" ng-transclude-slot="mwMediaContactDocumentTitle"></ng-transclude>
              <ng-transclude md-truncate flex="initial
              " ng-transclude-slot="mwMediaContactDocumentSource"></ng-transclude>
            </div>
            <div md-truncate ng-if="$ctrl.$transclude.isSlotFilled('mwMediaContactDocumentAddress')">
                <ng-transclude ng-transclude-slot="mwMediaContactDocumentAddress"></ng-transclude>
            </div>
        </div>
        <ng-transclude class="mw-media-contact-document-header__actions" flex="noshrink" ng-transclude-slot="mwContentDocumentActions"><div></div></ng-transclude>
    </div>
`;


@Component({
    selector: 'mw-media-contact-document-header',
    template: template,
    legacy: {
        transclude: {
            mwContentDocumentActions: '?mwContentDocumentActions',
            mwMediaContactDocumentAddress: '?mwMediaContactDocumentAddress',
            mwContentDocumentSourceAvatar: '?mwContentDocumentSourceAvatar',
            mwContentDocumentAuthor: '?mwContentDocumentAuthor',
            mwMediaContactDocumentSource: '?mwMediaContactDocumentSource',
            mwMediaContactDocumentTitle: '?mwMediaContactDocumentTitle',
        }
    }
})
export class MediaContactDocumentHeaderComponent {

    constructor(@Inject('$transclude') private $transclude: angular.ITranscludeFunction) {
        'ngInject'
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-contact-document/header/header.component.ts